// extracted by mini-css-extract-plugin
module.exports = {"header":"FormSwitcher_header__fKhpw","radio":"FormSwitcher_radio__1yMD3"};